module.exports = __webpack_public_path__ + "img/图片15.0000ed27.png";